import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/navPopularStores';

export const NAV_POPULAR_STORES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const NAV_POPULAR_STORES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
